import React, { PureComponent } from 'react';
import { Button } from 'nallian-shared-ui/lib/components';
import FileSaver from 'file-saver';
import axios from 'axios';
import { lightFormat } from 'date-fns';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';
import apiRoutes from '../../../app/api/routes';

class AccessRightFormModal extends PureComponent {
  state = {
    downloading: false,
  };
  downloadCsv = () => {
    this.setState({
      downloading: true,
    });

    const self = this;

    axios
      .get(apiRoutes.accessRightsCsv(), {
        headers: {
          Accept: 'application/octet-stream',
        },
        responseType: 'blob',
      })
      .then(response => {
        FileSaver.saveAs(
          response.data,
          `${appsettings.accessRightsCsvFilenamePrefix}${lightFormat(new Date(), 'yyyy-MM-dd')}.csv`
        );
      })
      .finally(() => {
        self.setState({
          downloading: false,
        });
      });
  };
  render() {
    return (
      <Button
        icon="download"
        content="CSV"
        onClick={this.downloadCsv}
        loading={this.state.downloading}
      />
    );
  }
}

export default AccessRightFormModal;
